
  <div class="modal-body modal-padding">
    <h5>Choose Layer</h5>
    <p [innerHtml]="text | sanitizeHtml">
    </p>
    <div class="button-wrapper">
      <button class="modal-button-style" data-dismiss="modal" (click)="close()">Ok</button>
    </div>
  </div>
